module.exports = __webpack_public_path__ + "img/case-banner__img1.png?bf462d92e7a98323faf69fc8ba6c9322";